import { Component, OnInit, EventEmitter, Output, ViewChild, ElementRef, HostListener, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { MENU } from './menu';
import { MenuItem } from './menu.model';
import { CookieService } from 'ngx-cookie-service';
import { User } from './../../../core/authservice/user.model';
import { Subject, takeUntil } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { AppState, selectMenuItems } from '../menu/menu.selectors';
import { Store } from '@ngrx/store';



@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  standalone: false
})
export class SidebarComponent implements OnInit, OnDestroy {
  

  menu: any;
  toggle: any = true;
  menuItems: MenuItem[] = [];
  fixedMenuItems: MenuItem[] = MENU; 
  user?: User;
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  isMobileView: boolean;

  @ViewChild('sideMenu') sideMenu!: ElementRef;
  @Output() mobileMenuButtonClicked = new EventEmitter();


  constructor(
    public _cookieService: CookieService,
    public translate: TranslateService,
    private store: Store<AppState>
    ) {
      this.isMobileView = window.innerWidth <= 767;
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.isMobileView = window.innerWidth <= 767;
  }

  ngOnInit(): void {
    // Get user from localStorage
    const storedUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
    this.user = storedUser;

    // Subscribe to store menu and merge static + dynamic
    this.store.select(selectMenuItems).pipe(takeUntil(this._unsubscribeAll)).subscribe({
      next: (dynamicMenu) => {
    
        this.menuItems = this.mergeMenuItems(this.user?.role, dynamicMenu);
        this.filterMenuByRole();
      },
      error: (err) => {
        console.error('Sidebar store subscription error:', err);
        this.menuItems = MENU; // Fallback to static menu if error occurs
      }
    });
  }

  /**
   * Merges static `MENU` items with dynamic menu fetched from backend.
   */
  private mergeMenuItems(role: string | undefined, dynamicMenu: MenuItem[]): MenuItem[] {
    if (!role) return MENU; // If no role, return static menu only
    let mergedMenu: MenuItem[] = []; // Start with static menu
    if (role === 'Teacher') {
      mergedMenu = [

        ...mergedMenu, // Keep static menu
        ...dynamicMenu  // Merge with dynamic
      ];
    } else if (role === 'Admin') {
      mergedMenu = [
        { id: 54, label: 'general.schoolSystem', isTitle: true },
        ...mergedMenu, // Keep static menu
        ...dynamicMenu  // Merge with dynamic
      ];
    } else {
      mergedMenu = [...mergedMenu, ...dynamicMenu]; // Default merge
    }

    return mergedMenu;
  }

  /**
   * Filters menu items based on user role.
   */
  filterMenuByRole(): void {
    const allMenuItems = [ ...this.menuItems,...MENU];
  
    this.menuItems = allMenuItems.filter(item => {
      // Check if the item should be shown based on the user's role
      const roleCheck = !item.roles || item.roles.includes((this.user as any).role);

      return roleCheck;
    }).map(item => {
      const updatedItem = { ...item };

      return {
        ...updatedItem,
        subItems: updatedItem.subItems?.filter((subItem: any) => {
          return !subItem.roles || subItem.roles.includes((this.user as any).role);
        }),
      };
    });
  }




  /***
   * Activate droup down set
   */
  ngAfterViewInit() {
    setTimeout(() => {
      this.initActiveMenu();
    }, 0);
  }


  removeActivation(items: any) {
    items.forEach((item: any) => {
      if (item.classList.contains("menu-link")) {
        if (!item.classList.contains("active")) {
          item.setAttribute("aria-expanded", false);
        }
        (item.nextElementSibling) ? item.nextElementSibling.classList.remove("show") : null;
      }
      if (item.classList.contains("nav-link")) {
        if (item.nextElementSibling) {
          item.nextElementSibling.classList.remove("show");
        }
        item.setAttribute("aria-expanded", false);
      }
      item.classList.remove("active");
    });
  }

  toggleSubItem(event: any) {
    let isCurrentMenuId = event.target.closest('a.nav-link');
    let isMenu = isCurrentMenuId.nextElementSibling as any;
    if (isMenu.classList.contains("show")) {
      isMenu.classList.remove("show");
      isCurrentMenuId.setAttribute("aria-expanded", "false");
    } else {
      let dropDowns = Array.from(document.querySelectorAll('.sub-menu'));
      dropDowns.forEach((node: any) => {
        node.classList.remove('show');
      });

      let subDropDowns = Array.from(document.querySelectorAll('.menu-dropdown .nav-link'));
      subDropDowns.forEach((submenu: any) => {
        submenu.setAttribute('aria-expanded', "false");
      });

      if (event.target && event.target.nextElementSibling) {
        isCurrentMenuId.setAttribute("aria-expanded", "true");
        event.target.nextElementSibling.classList.toggle("show");
      }
    }
  };

  toggleExtraSubItem(event: any) {
    let isCurrentMenuId = event.target.closest('a.nav-link');
    let isMenu = isCurrentMenuId.nextElementSibling as any;
    if (isMenu.classList.contains("show")) {
      isMenu.classList.remove("show");
      isCurrentMenuId.setAttribute("aria-expanded", "false");
    } else {
      let dropDowns = Array.from(document.querySelectorAll('.extra-sub-menu'));
      dropDowns.forEach((node: any) => {
        node.classList.remove('show');
      });

      let subDropDowns = Array.from(document.querySelectorAll('.menu-dropdown .nav-link'));
      subDropDowns.forEach((submenu: any) => {
        submenu.setAttribute('aria-expanded', "false");
      });

      if (event.target && event.target.nextElementSibling) {
        isCurrentMenuId.setAttribute("aria-expanded", "true");
        event.target.nextElementSibling.classList.toggle("show");
      }
    }
  };

  // Click wise Parent active class add
  toggleParentItem(event: any) {
    let isCurrentMenuId = event.target.closest('a.nav-link');
    let dropDowns = Array.from(document.querySelectorAll('#navbar-nav .show'));
    dropDowns.forEach((node: any) => {
      node.classList.remove('show');
    });
    const ul = document.getElementById("navbar-nav");
    if (ul) {
      const iconItems = Array.from(ul.getElementsByTagName("a"));
      let activeIconItems = iconItems.filter((x: any) => x.classList.contains("active"));
      activeIconItems.forEach((item: any) => {
        item.setAttribute('aria-expanded', "false")
        item.classList.remove("active");
      });
    }
    isCurrentMenuId.setAttribute("aria-expanded", "true");
    if (isCurrentMenuId) {
      this.activateParentDropdown(isCurrentMenuId);
    }
  }

  toggleItem(event: any) {
    let isCurrentMenuId = event.target.closest('a.nav-link');
    let isMenu = isCurrentMenuId.nextElementSibling as any;
    if (isMenu.classList.contains("show")) {
      isMenu.classList.remove("show");
      isCurrentMenuId.setAttribute("aria-expanded", "false");
    } else {
      let dropDowns = Array.from(document.querySelectorAll('#navbar-nav .show'));
      dropDowns.forEach((node: any) => {
        node.classList.remove('show');
      });
      (isMenu) ? isMenu.classList.add('show') : null;
      const ul = document.getElementById("navbar-nav");
      if (ul) {
        const iconItems = Array.from(ul.getElementsByTagName("a"));
        let activeIconItems = iconItems.filter((x: any) => x.classList.contains("active"));
        activeIconItems.forEach((item: any) => {
          item.setAttribute('aria-expanded', "false")
          item.classList.remove("active");
        });
      }
      isCurrentMenuId.setAttribute("aria-expanded", "true");
      if (isCurrentMenuId) {
        this.activateParentDropdown(isCurrentMenuId);
      }
    }
  }

  // remove active items of two-column-menu
  activateParentDropdown(item: any) {
 
    item.classList.add("active");
    let parentCollapseDiv = item.closest(".collapse.menu-dropdown");
    if (parentCollapseDiv) {
      // to set aria expand true remaining
      parentCollapseDiv.classList.add("show");
      parentCollapseDiv.parentElement.children[0].classList.add("active");
      parentCollapseDiv.parentElement.children[0].setAttribute("aria-expanded", "true");
      if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")) {
        parentCollapseDiv.parentElement.closest(".collapse").classList.add("show");
        if (parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling)
          parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.classList.add("active");
        if (parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.closest(".collapse")) {
          parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.closest(".collapse").classList.add("show");
          parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.closest(".collapse").previousElementSibling.classList.add("active");
        }
      }
      return false;
    }
    return false;
  }

  updateActive(event: any) {
    const ul = document.getElementById("navbar-nav");
    if (ul) {
      const items = Array.from(ul.querySelectorAll("a.nav-link"));
      this.removeActivation(items);
    }
    this.activateParentDropdown(event.target);
  }

  initActiveMenu() {
    const pathname = window.location.pathname; // Current path
    const ul = document.getElementById("navbar-nav");
    if (ul) {
      const items = Array.from(ul.querySelectorAll("a.nav-link"));
      this.removeActivation(items);
  
      // Find the menu item where the current path starts with its routerLink
      let matchingMenuItem = items.find((item: any) => {
        const menuLink = item.getAttribute('routerLink') || item.getAttribute('href');
        if (!menuLink) return false;
  
        // Ensure pathname starts with the menuLink
        return pathname.startsWith(menuLink);
      });
  
      if (matchingMenuItem) {
        this.activateParentDropdown(matchingMenuItem);
      }
    }
  }
  
  // Helper function to strip dynamic segments from the path
  getBaseRoute(path: string): string {
    // Strip any numeric segments and trailing slashes from the path
    return path.replace(/\/\d+($|\/)/g, '/').replace(/\/$/, '');
  }
  
  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    var sidebarsize = document.documentElement.getAttribute("data-sidebar-size");
    let newSize = 'sm-hover';
  
    if (sidebarsize == 'sm-hover-active') {
      newSize = 'sm-hover';
    } else {
      newSize = 'sm-hover-active';
    }
    document.documentElement.setAttribute("data-sidebar-size", newSize);
    // Save the new size to a cookie
    this._cookieService.set('sidebarSize', newSize);
  }
  /**
   * SidebarHide modal
   * @param content modal content
   */
  SidebarHide() {
    document.body.classList.remove('vertical-sidebar-enable');
  }
  ngOnDestroy(): void
  {
      // Unsubscribe from all subscriptions
      this._unsubscribeAll.next(null);
      this._unsubscribeAll.complete();
  }
}
